import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MissingTranslationHandler, TranslateLoader, TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { HttpLoaderFactory } from './translations.factories';
import { HttpClient } from '@angular/common/http';
import { LobbyMissingTranslationHandler } from './lobby-missing-translation.handler';



@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      defaultLanguage: 'IT-it',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient]
      },
      missingTranslationHandler: { provide: MissingTranslationHandler, useClass: LobbyMissingTranslationHandler },
      extend: true
    })
  ],
  providers: [TranslatePipe],
  exports: [TranslateModule]
})
export class TranslationsModule { }
